module.exports = __webpack_public_path__ + "static/media/G1141311_Korea-17.b4464f04.png";